export default __webpack_public_path__ + "static/media/exoneradas_ande.f622df56.svg";